/**
 * Menü seed olmadan çalışma saatleri route'larını routeList'e ekler.
 * routes.js'den ayrı tutulur; DefaultLayout ↔ routes döngüsel bağımlılık riskini azaltır.
 */
export const WORKING_HOURS_ROUTE_PATHS = [
  "/calisma-saatleri",
  "/calisma-saatleri/yeni",
  "/calisma-saatleri/:id",
  "/giris-loglari",
];

export const ensureWorkingHoursRoutes = (routeList, allRoutes) => {
  const next = Array.isArray(routeList) ? [...routeList] : [];
  if (!Array.isArray(allRoutes)) return next;

  WORKING_HOURS_ROUTE_PATHS.forEach((path) => {
    const route = allRoutes.find((item) => item && item.path === path);
    if (route && !next.some((item) => item.path === route.path)) {
      next.push(route);
    }
  });
  return next;
};
